import { DeviceDetection } from "oc-commons/DeviceDetection";

/**
 * IOS 10 safari ingoriert user-scalable=no, hiermit wird es wieder eigeschaltet.
 * Funktioniert, indem alle Zoom/Pinch-Gesten ausgeschaltet werden.
 * Leider kann der User manchmal doch noch in den Zoommodus gelangen, aber wenn das so ist,
 * wird es erkannt und man kann ab da die IOS-Zoomgesten wieder frei verwenden, bis man wieder in die normale
 * Ansicht zurückgezoomed hat.
 */
const contentAttribute = document.querySelector("meta[name=viewport]")?.getAttribute("content");
if (
    DeviceDetection.isIOS() &&
    contentAttribute &&
    /user-scalable\s*=\s*no/.test(contentAttribute)
) {
    const isUnZoomed = () => {
        const physicalWidth =
            Math.abs(window.orientation as any) == 90 ? window.screen.height : window.screen.width;
        const zoomedWidth1 = document.body.clientWidth;
        const zoomedWidth2 = window.innerWidth;
        return zoomedWidth1 == zoomedWidth2 && zoomedWidth1 == physicalWidth;
    };
    document.addEventListener("gesturestart", (e) => {
        if (isUnZoomed()) {
            e.preventDefault();
        }
    });
    document.addEventListener("touchstart", (e) => {
        if (e.touches && e.touches.length > 1) {
            if (isUnZoomed()) {
                e.preventDefault();
            }
        }
    });
    let lastTouchEnd = 0;
    document.addEventListener("touchend", (e) => {
        const now = performance.now();
        if (now - lastTouchEnd <= 300) {
            if (isUnZoomed()) {
                e.preventDefault();
            }
        }
        lastTouchEnd = now;
    });
}
